import {useContext} from 'react';
import PropTypes from 'prop-types';
import './SkipToMainLink.css';
import {I18nContext} from 'react-i18next';

function SkipToMainLink(props) {
	const t = useContext(I18nContext).i18n.t;

	return (
		<a href={props.href} className={(props.className ?? '') + ' skip-to-main'}>
			{t('app.skipToMain')}
		</a>
	);
}

SkipToMainLink.propTypes = {
	className: PropTypes.string,
	href: PropTypes.string.isRequired
};

export default SkipToMainLink;
